import Hero from "./components/Hero";
import { CategorySection, FeaturedLeads } from "./components/Sections";
import {
  CtaSection,
  FaqSection,
  PrinciplesSection,
  ProcessSection,
  TestimonialSection,
} from "./components/Sections2";
import { useSeo, BASE_URL } from "@/hooks/useSeo";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import { faqs } from "@/mocks/leads";

export default function Home() {
  useScrollReveal();

  useSeo({
    title: "蝌蚪爆料 - 一手线索投稿入口｜私信来源与内幕线索征集平台",
    description:
      "蝌蚪爆料是专注线索征集的投稿平台，提供一手线索投稿入口、私信来源与内幕对接通道，欢迎提供真实素材。不追风不编造，每一条线索都认真核实后呈现，投稿人身份默认匿名保护。",
    keywords: "蝌蚪爆料,蝌蚪爆料投稿,蝌蚪爆料线索,蝌蚪爆料私信,蝌蚪爆料内幕,蝌蚪爆料来源,蝌蚪爆料征集",
    path: "/",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "蝌蚪爆料",
        url: BASE_URL,
        description:
          "线索投稿与信息核实平台，为提供真实素材的投稿人与关注公共议题的读者搭建可信的对接通道。",
        email: "tips@kedoubaoliao.cn",
        contactPoint: {
          "@type": "ContactPoint",
          telephone: "400-826-3018",
          contactType: "线索投稿与来源对接",
          areaServed: "CN",
          availableLanguage: "zh-CN",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "蝌蚪爆料",
        url: BASE_URL,
        inLanguage: "zh-CN",
        potentialAction: {
          "@type": "SearchAction",
          target: {
            "@type": "EntryPoint",
            urlTemplate: `${BASE_URL}/leads?q={search_term_string}`,
          },
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((f) => ({
          "@type": "Question",
          name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      },
    ],
  });

  return (
    <>
      <Hero />
      <CategorySection />
      <FeaturedLeads />
      <ProcessSection />
      <PrinciplesSection />
      <TestimonialSection />
      <FaqSection />
      <CtaSection />
    </>
  );
}